import React from 'react'
import moment from 'moment'
import debounce from 'debounce'

import {
    Button,
    Card,
    Table,
    Row,
    Col,
    Input,
    message,
    Badge,
    Modal,
    Divider,
    Popconfirm,
    Tag
} from 'antd'

import { 
    _getSearchEnterprise, 
    _postAddEnterprise, 
    _postEditEnterprise,
    _deleteEnterprise,
    _getCreditData
} from '../../services'

import EnterpriseForm from './form'

const { confirm,info } = Modal

class EnterpriseManager extends React.Component{

    render(){

        const columns = [{
            title: "#",
            width: 50,
            render:(text, record, index)=> {
                return this.state.count - (index + ((this.state.page - 1) * this.state.limit))
            }
        },{
            title: "Logo",
            dataIndex: 'logoUrl',
            render: (logoUrl) => (
                <img 
                src={logoUrl}
                style={{ height: 50, maxWidth: 200 }}/>
            )
        },{
            title: "Enterprise",
            dataIndex: "companyName",
            render: (companyName, record) => {

                if( record.punchoutApplicationDetails && !record.punchoutModule ){
                    return (
                        <div>
                            {companyName} <Button
                            ghost
                            type="primary"
                            size="small"
                            onClick={()=>(
                                info({
                                    centered: true,
                                    title: 'Application Details',
                                    content: this.renderPunchoutApplicationDetails(record.punchoutApplicationDetails, record.contactUsIntention)
                                })
                            )}
                            >Application Details</Button>
                        </div>
                    )
                }

                return companyName
            }
        },{
            title: 'Tier',
            dataIndex: 'tier',
            render: (tier) => (
                tier? tier : '-'
            )
        },{
            title: 'Modules',
            dataIndex: 'modules',
            render: (modules, record) => {
                return(
                    <Row type="flex">
                        {modules && Object.keys(modules).map( _moduleKey => {
                            if( modules[_moduleKey] ){
                                return <Tag>{_moduleKey}</Tag>
                            }
                        })}
                        {record.punchoutModule && <Tag>punchout</Tag>}
                    </Row>
                )
            }
        },{
            title: 'Quickbooks',
            dataIndex: 'quickbooks',
            render: (quickbooks) => quickbooks && quickbooks.buyer && quickbooks.buyer.displayName 
        },{
            title: 'Lead',
            dataIndex: 'salesAgent',
            render: (salesAgent, record) => ( record.salesAgent && record.salesAgent.email ) || '-'
        },{
            title: 'Status',
            dataIndex: 'isLive',
            render: (isLive) => <Badge text={isLive?'Live':'Offline'} status={isLive?'success':'error'}/>
        },{
            title: "Actions",
            render:(text, record) => {
                return(
                    <Row>
                        {/* <a
                            onClick={()=>this.handleEditEnterprise(record)}
                        >
                            Edit
                        </a>
                        <Divider type="vertical"/> */}
                         <a
                            href={`/enterprise/${record._id}`}
                            target={`view_${record.companyName}`}
                        >
                            View
                        </a>
                        <Divider type="vertical"/>
                        <a onClick={()=>this.handleCheckCredit(record)}>
                            Credit
                        </a>
                        <Divider type="vertical"/>
                        <Popconfirm
                            title={`Delete ${record.companyName}?`}
                            onConfirm={()=>this.deleteEnterprise(record._id)}                        
                        >
                            <a
                                style={{color: '#f5222d'}}
                            >
                                Delete
                            </a>
                        </Popconfirm>
                        
                    </Row>
                )
            }
        }]

        const { activeEnterprise, enterprises, page, searchTerm, count, limit, visible } = this.state

        return(
            <div style={{margin: 16}}>
                {this.state.renderModal && <Modal
                    afterClose={()=>{
                        this.setState({
                            renderModal: false,
                            activeEnterprise: false
                        })
                    }}
                    centered
                    footer={null}
                    visible={visible}
                    closable
                    onCancel={this.closeModal}
                >
                    <EnterpriseForm
                        activeEnterprise={activeEnterprise}
                        addEnterprise={this.addEnterprise}
                        editEnterprise={this.editEnterprise}
                    />
                </Modal>}
                <Card
                    title={
                        <Row type="flex" justify="space-between">
                            <Col>
                                <Input
                                    onChange={this.handleOnChangeSearch}
                                    placeholder="Search enterprise name"
                                />
                            </Col>
                            <Col>
                                <Button
                                    onClick={this.openModal}
                                    type="primary"
                                >
                                    Add Enterprise
                                </Button>
                            </Col>
                        </Row>
                    }
                >
                    <Table
                        loading={this.state.loading}
                        columns={columns}
                        pagination={{
                            total: count,
                            current: page,
                            pageSize: limit,
                            onChange: this.handlePageChange
                        }}
                        dataSource={enterprises}
                    />
                </Card>
            </div>
        )
    }

    constructor(props){
        super(props)

        this.state = {
            enterprises: false,
            page: 1,
            searchTerm: "",
            count: false,
            limit: 10,
            visible: false,
            activeEnterprise: false,
            renderModal: false
        }

        this.handleSearch = debounce(this.handleSearch, 400)
    }

    componentWillMount(){
        this.getEnterprises()
    }

    addEnterprise = (data) => {
        _postAddEnterprise(data)
        .then( res => {
            this.getEnterprises()
            this.closeModal()
        })
    }

    handleCheckCredit = async (enterprise) => {

        const xhr = await _getCreditData(enterprise._id);
        const creditData = xhr.data;

        return info({
            title: "Credit Info",
            content: `Credit Limit: ${creditData.creditLimit}\nCredit Utilisation: ${creditData.creditUtilisation}\nCredit Balance: ${creditData.creditBalance}`,
            centered: true
        })

    }

    deleteEnterprise = (enterpriseId) => {
        _deleteEnterprise(enterpriseId)
        .then( res => {
            this.getEnterprises()
        })
    }

    editEnterprise = ({enterpriseId, data}) => {
        _postEditEnterprise({
            enterpriseId,
            data
        })
        .then( res => {
            this.getEnterprises()
            this.closeModal()
        })
    }

    closeModal = () =>{
        this.setState({visible: false})
    }

    openModal = () =>{
        this.setState({
            visible: true,
            renderModal: true
        })
    }

    getEnterprises = () => {
        const { page, searchTerm, limit } = this.state

        this.setState({
            loading: true
        })

        _getSearchEnterprise({
            searchTerm,
            page,
            limit
        })
        .then( res => {

            const { enterprises, count } = res.data

            this.setState({
                loading: false,
                enterprises,
                count
            })
        })
    }

    handleEditEnterprise = (activeEnterprise) => {
        this.setState({
            activeEnterprise,
            renderModal: true,
            visible: true
        })
    }

    handleOnChangeSearch = (e) => {
        this.handleSearch(e.target.value)
    } 

    handlePageChange = (page) => {
        this.setState({page}, this.getEnterprises)
    }

    handleSearch = (searchTerm) => {
        this.setState({
            searchTerm,
            page: 1
        }, this.getEnterprises)
    }

    renderPunchoutApplicationDetails = ( details, contactUsIntention ) => {

        details.contactDate = moment(details.contactDate).format("LLLL")

        return (
            <Row>
                {Object.keys(details).map(_key => {
                    return (
                    <Row type="flex">
                        <Col span={12}>{_key}</Col>
                        <Col span={12}>{details[_key]}</Col>
                    </Row>
                    )
                })}
                <Row type="flex">
                    <Col span={12}>contactUsIntention</Col>
                    <Col span={12}>{contactUsIntention.map(_intention => <Tag>{_intention}</Tag>)}</Col>
                </Row>
            </Row>
            
        )
    }
}

export default EnterpriseManager


// WEBPACK FOOTER //
// ./src/components/enterprise/index.js